<template>
  <footer class="site-footer">
    <div class="site-footer__inner">
      <div class="site-footer__col site-footer__col--brand">
        <div class="site-footer__brand-title">PAXA</div>
        <p class="site-footer__brand-text">
          听见自己，更懂世界。PAXA致力于为现代女性打造兼具美学与智能的音频产品，让科技有温度，让美不妥协。
        </p>
        <div class="site-footer__social" aria-label="社交媒体">
          <a
            href="#"
            class="site-footer__social-btn"
            aria-label="微信"
            @click.prevent="onSocialClick('wechat')"
          >
            <span class="site-footer__social-icon" aria-hidden="true">微</span>
          </a>
          <a
            href="#"
            class="site-footer__social-btn"
            aria-label="更多平台"
            @click.prevent="onSocialClick('other')"
          >
            <span class="site-footer__social-icon" aria-hidden="true">+</span>
          </a>
        </div>
      </div>

      <div class="site-footer__col">
        <h2 class="site-footer__heading">产品中心</h2>
        <button
          type="button"
          class="site-footer__link"
          @click="onProductSeries"
        >
          CrysClip 系列
        </button>
      </div>

      <div class="site-footer__col">
        <h2 class="site-footer__heading">支持</h2>
        <ul class="site-footer__list">
          <li v-for="item in supportLinks" :key="item.key">
            <button
              type="button"
              class="site-footer__link"
              @click="onSupportClick(item.key, item.label)"
            >
              {{ item.label }}
            </button>
          </li>
        </ul>
      </div>

      <div class="site-footer__col">
        <h2 class="site-footer__heading">联系我们</h2>
        <p class="site-footer__contact">
          地址：深圳市龙华区北站社区数字创新中心(海源厦北站中心), A栋904<br />
          邮箱：PAXA@SZPAXA.COM.CN<br />
          电话：13417309649
          <a href="https://beian.miit.gov.cn" style="text-underline: none;text-decoration: none;color: white">粤ICP备2026058879号-1</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
/** 支持区链接：key 便于后续接路由或锚点 */
const SUPPORT_LINKS = [
  { key: 'guide', label: '使用指南' },
  { key: 'service', label: '售后服务' },
  { key: 'warranty', label: '保修政策' },
  { key: 'faq', label: '常见问题' },
  { key: 'customer', label: '联系客服' }
]

export default {
  name: 'SiteFooter',
  data() {
    return {
      /** 支持栏链接配置 */
      supportLinks: SUPPORT_LINKS
    }
  },
  methods: {
    /** CrysClip：进入产品中心 */
    onProductSeries() {
      console.info('[SiteFooter] 点击 CrysClip 系列 → 产品中心')
      this.$router.push({ name: 'product' }).catch((err) => {
        console.error('[SiteFooter] 路由跳转失败:', err)
      })
    },
    /** 支持区占位：后续可接独立页面 */
    onSupportClick(key, label) {
      console.info('[SiteFooter] 支持链接点击:', key, label)
    },
    /** 社交入口占位 */
    onSocialClick(platform) {
      console.info('[SiteFooter] 社交入口点击:', platform)
    }
  }
}
</script>

<style scoped>
.site-footer {
  width: 100%;
  box-sizing: border-box;
  background: #000;
  color: #fff;
  padding: 56px 0 48px;
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.site-footer__inner {
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 0 clamp(24px, 4vw, 48px);
  box-sizing: border-box;
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 0.75fr) minmax(0, 0.95fr) minmax(
      0,
      1.15fr
    );
  gap: clamp(28px, 4vw, 48px);
  align-items: start;
}

.site-footer__col--brand {
  padding-right: clamp(0px, 2vw, 24px);
}

.site-footer__brand-title {
  font-size: clamp(17px, 1.4vw, 20px);
  font-weight: 600;
  letter-spacing: 0.14em;
  margin-bottom: 16px;
}

.site-footer__brand-text {
  margin: 0 0 22px;
  font-size: clamp(12px, 1vw, 14px);
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.82);
  font-weight: 400;
}

.site-footer__social {
  display: flex;
  gap: 12px;
}

.site-footer__social-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.35);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #fff;
  font-size: 13px;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.site-footer__social-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.55);
}

.site-footer__heading {
  margin: 0 0 16px;
  font-size: clamp(13px, 1.05vw, 15px);
  font-weight: 600;
  letter-spacing: 0.06em;
}

.site-footer__list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.site-footer__link {
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  font: inherit;
  font-size: clamp(12px, 0.98vw, 14px);
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.5;
  transition: color 0.15s ease;
}

.site-footer__link:hover {
  color: #fff;
}

.site-footer__contact {
  margin: 0;
  font-size: clamp(12px, 0.98vw, 14px);
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.78);
}

@media (max-width: 960px) {
  .site-footer__inner {
    grid-template-columns: 1fr 1fr;
  }

  .site-footer__col--brand {
    grid-column: 1 / -1;
    padding-right: 0;
  }
}

@media (max-width: 560px) {
  .site-footer__inner {
    grid-template-columns: 1fr;
  }
}
</style>
